import { currencySymbol } from './currency';
// proposalCatalog.js — shared formatting helpers & configuration option lists.
// Product prices and rates come from the database.

// ─── Configuration Options ─────────────────────────────────
export const LICENSE_TYPES = [
  { value: 'BASIC', label: 'BÁSICA' },
  { value: 'PRO',   label: 'PRO' },
  { value: 'NONE',  label: 'Sin Licencia' },
]

export const MAINTENANCE_TYPES = [
  { value: 'ESTANDAR', label: 'ESTÁNDAR' },
  { value: 'PREMIUM',  label: 'PREMIUM' },
  { value: 'NONE',     label: 'Sin Mtto.' },
]

export const ZONES = [
  { value: 'ZONA_I',   label: 'ZONA I - España Peninsular, Portugal, Baleares' },
  { value: 'ZONA_II',  label: 'ZONA II - Islas Canarias, Francia, Italia, Alemania' },
  { value: 'ZONA_III', label: 'ZONA III - Resto de Europa' },
  { value: 'ZONA_IV',  label: 'ZONA IV - América, Asia, Oceanía' },
]

export const LOCKER_RANGES = [
  { value: 'default', label: 'Tarifa única' },
]

export const SALE_MODES = [
  { value: 'purchase',      label: 'Compra' },
  { value: 'rental',        label: 'Alquiler' },
  { value: 'revenue_share', label: 'Revenue Share' },
]

export const OPERATING_MODES = [
  { value: '24H',        label: '24H' },
  { value: 'Tiempo',     label: 'Tiempo' },
  { value: 'Apertura',   label: 'Apertura' },
  { value: 'Paqueteria', label: 'Paquetería' },
]

export const INSTALLATION_TYPES = [
  { value: 'interior', label: 'Estándar' },
]

export const LOCK_TYPES = [
  { value: 'STANDARD', label: 'Standard' },
]

// ─── Formatting Helpers ────────────────────────────────────
export const fmt = (n) => {
  if (n === 0) return '-'
  return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ` ${currencySymbol()}`
}

export const fmtAlways = (n) => {
  return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ` ${currencySymbol()}`
}

export const fmtPct = (n) => {
  return n.toFixed(2) + '%'
}
